import Request from '@/jslib/dk-axios'

export const storeList = (data) => {
  return Request({
    url: 'Experience',
    method: 'GET',
    params: data,
  })
}

export const addStore = (data) => {
  return Request({
    url: 'Experience',
    method: 'POST',
    data,
  })
}

export const editStore = (data) => {
  return Request({
    url: `Experience/${data.uuid}`,
    method: 'PUT',
    data,
  })
}

export const delStore = (data) => {
  return Request({
    url: `Experience/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}

export const storeDetail = (data) => {
  return Request({
    url: `Experience/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/store.js